import React, { useEffect, useRef, useState } from "react";
import { Form, Col, Row } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import Title from "../../../components/Admin/Title";
import useIsAdmin from "../../../hooks/useIsAdmin";
import ErrorPage from "../../ErrorPage";
import { useUser } from "../../../components/UserContext";
import Button from "../../../components/Button";
import LoadingContent from "../../../components/LoadingContent";

const NoOfficialLogos = () => {
  const { access } = useIsAdmin();
  document.title = "LVF1 - No Official Logos";
  const { user } = useUser() as any;
  const refPicture = useRef<any>(null);
  const token = window.localStorage.getItem("userLogged");
  const [dataForm, setDataForm] = useState({
    team: "",
  });
  const [validated, setValidated] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [data, setData] = useState<
    {
      engine: string;
      logo: string | null;
    }[]
  >([]);
  const [logoSrc, setLogoSrc] = useState<string>("");
  const [showNoImage, setShowNoImage] = useState<boolean>(false);
  const [picture, setPicture] = useState();

  useEffect(() => {
    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/team/getTeamsWithNoId`,
      )
      .then(({ data }) => {
        setData(data.teams);
      })
      .catch(({ response }) => {
        toast.error(response.data.message);
        setUploading(false);
        throw new Error(response);
      });
  }, []);

  const inputChange = ({ target }: { target: any }) => {
    const { name, value } = target;
    setDataForm({
      ...dataForm,
      [name]: value,
    });
  };

  const submitForm = (event: any) => {
    if (token == null) return;
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    const formDataFiles = new FormData();
    formDataFiles.append("user", user);
    formDataFiles.append("token", JSON.parse(token).token);
    formDataFiles.append("logoSrc", logoSrc);
    if (picture != null) formDataFiles.append("team_logo", picture);

    if (!(form !== null && form.checkValidity() === false)) {
      setUploading(true);
      axios
        .post(
          `${
            process.env.NODE_ENV === "development"
              ? "http://localhost:5500"
              : "https://ligavirtualf1.es:5500"
          }/api/admin/uploadNoOfficialLogo`,
          formDataFiles,
        )
        .then(() => {
          toast.success("Team logo updated successfully");
          setUploading(false);
          setValidated(false);
        })
        .catch(({ response }) => {
          toast.error(response.data.message);
          setUploading(false);
          throw new Error(response);
        });
    }
    setValidated(true);
  };

  if (data.length == 0) return <LoadingContent />;
  if (!access) return <ErrorPage />;
  return (
    <div className="full-height padding-md app-container flex-center-top page-transition">
      <div className="form-container">
        <Title text="No Official Logos" />
        <small className="mandatory-fields">(*) Required fields</small>
        <Form noValidate validated={validated} onSubmit={submitForm}>
          <Row className="mb-3">
            <Form.Group className="form-group" as={Col} md="6">
              <Form.Label>Team (*)</Form.Label>
              <Form.Select
                name="team"
                value={dataForm.team}
                required
                onChange={(e) => {
                  inputChange(e);
                  const engine = e.target.value.split("$$")[0];
                  setLogoSrc(`/assets/Teams/General/${engine}.png`);
                  setShowNoImage(false);
                }}
              >
                <option disabled value={""}>
                  None
                </option>
                {data.map((team, index) => {
                  const logo = team.logo == null ? "" : "" + team.logo;
                  const name_with_logo =
                    team.logo == null || team.logo == ""
                      ? team.engine
                      : `${team.engine}_${logo}`;
                  return (
                    <option value={name_with_logo} key={index}>
                      {team.engine} {logo}
                    </option>
                  );
                })}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Field required
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="form-group" as={Col} md="6">
              <Form.Label>Logo</Form.Label>
              {logoSrc && !showNoImage && (
                <img
                  src={logoSrc}
                  alt="Logo"
                  style={{ maxWidth: "100px", maxHeight: "50px" }}
                  onError={() => setShowNoImage(true)}
                />
              )}
              {showNoImage && <p>No image has been uploaded yet.</p>}
              <Form.Control.Feedback type="invalid">
                Field required
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="form-group" as={Col} md="12">
              <Form.Label>Image (*)</Form.Label>
              <Form.Control
                name="driver_picture"
                type="file"
                accept="image/*"
                required
                ref={refPicture}
                onChange={() => setPicture(refPicture.current.files[0])}
              />
              <Form.Control.Feedback type="invalid">
                Field required
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <div className="text-center">
            {uploading ? (
              <FontAwesomeIcon icon={faSpinner} className="spinner-button" />
            ) : (
              <Button text={"Update Image"} type="submit" />
            )}
          </div>
        </Form>
      </div>
    </div>
  );
};

export default NoOfficialLogos;
